import { useAuth } from 'react-oidc-context'
import type { OIDCUser } from '@/infra/auth'

export interface AuthStatusValue {
  readonly isAuthenticated: boolean
  readonly isLoading: boolean
  readonly user: OIDCUser | null | undefined
}

export function useAuthStatus(): AuthStatusValue {
  const auth = useAuth()

  return {
    isAuthenticated: !!auth.user && !auth.isLoading,
    isLoading: auth.isLoading,
    user: auth.user,
  }
}
